module.exports = __webpack_public_path__ + "img/calendar-minus-fill.d7a7cc61.svg";